import { render, staticRenderFns } from "./Flow.vue?vue&type=template&id=bfdd1aac&scoped=true&"
import script from "./Flow.vue?vue&type=script&lang=js&"
export * from "./Flow.vue?vue&type=script&lang=js&"
import style0 from "./Flow.vue?vue&type=style&index=0&id=bfdd1aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdd1aac",
  null
  
)

export default component.exports